import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ConfirmationModal, Typography } from 'seagull';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
export default function RemoveAccountantModal(props) {
    const { accountant, dismissModal, refresh } = props;
    const overlayContext = useOverlayContext();
    const { api, logBI } = useStoreActions();
    const { t: texts } = useLocaleKeys('pages.teamPage');
    const { t: commonTexts } = useLocaleKeys('common');
    const [loading, setLoading] = useState(false);
    async function submit() {
        setLoading(true);
        const vendorId = accountant.id();
        logBI(13105, {
            vendorId,
            companyName: accountant.companyName()
        });
        const { success } = await handlePromise(api.accountants.removeVendor(vendorId));
        if (!success) {
            overlayContext.showErrorToast(commonTexts.toasts.failedToRemoveAccountant(), 'acc-remove-failure');
        } else {
            await refresh();
        }
        dismissModal();
    }
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'remove_accountant_confirm'
            },
            secondaryButton: {
                name: 'remove_accountant_cancel'
            }
        },
        skin: "danger",
        textAlignCenter: false,
        title: texts.removeAccountantTitle(),
        primaryButtonLabel: commonTexts.buttons.removeAccountant(),
        primaryButtonTestId: "rm-acc-access-submit",
        primaryButtonLoading: loading,
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onCloseButtonClick: dismissModal,
        onSecondaryButtonClick: dismissModal,
        onPrimaryButtonClick: submit,
        content: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs(Typography, {
                    children: [
                        "Are you sure you want to remove accountant access to",
                        ' ',
                        /*#__PURE__*/ _jsx(Typography, {
                            as: "span",
                            weight: "normal",
                            children: accountant.companyName()
                        }),
                        "?"
                    ]
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.removeAccountantMessage()
                })
            ]
        })
    });
}
